import { Transition } from 'react-transition-group';
import { AlertPopupContainer } from '../alert-popup/alertPopup.styled';
import Button from '../button';
import Heading from '../typography';

interface confirmationModalType {
  isShow: boolean;
  title: string;
  handleClose: () => void;
  handleSubmit?: any;
  loading?: boolean;
}

const ConfirmationModal = ({
  isShow,
  handleClose,
  handleSubmit,
  loading,
  title,
}: confirmationModalType): JSX.Element => {
  return (
    <Transition in={isShow} timeout={250}>
      {(state) => (
        <AlertPopupContainer>
          <div className={`modalBackdrop modalBackdrop-${state}`}>
            <div className={`sideBar sideBar-${state} `}>
              <div className='popupDialog'>
                <div className='popupContent'>
                  <Heading
                    variant='h5'
                    className='mb-5'
                    title={`Are you sure you want to delete this ${title}?`}
                  />

                  <div className='popupButtons'>
                    <Button
                      variant='primary-dark'
                      title='Close'
                      onClick={() => {
                        handleClose();
                      }}
                    />
                    <Button
                      variant='primary'
                      title='Confirm'
                      onClick={handleSubmit}
                      icon={<span className='material-symbols-outlined'>check_circle</span>}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AlertPopupContainer>
      )}
    </Transition>
  );
};

export default ConfirmationModal;
